/*
  Kis website ka build hai — branding BUILD se tay hoti hai (22 Sep 2026).

  21 Sep ko shared website (hmserp.in) ke liye HMSERP ka logo, naam aur privacy page jode
  gaye the — seedhe source me. Par wahi source Kamla (kamlahms.in) ka build bhi banata hai,
  aur user ka faisla (22 Sep): **Kamla par wahi dikhe jo aaj live hai** — "HMS PORTAL",
  tab "HMS", HMSERP logo nahi, "Privacy Policy" sirf likha hua.

  Isliye:
      REACT_APP_BRAND=hmserp   → HMSERP (build_hmserp)
      kuch nahi                → purana naam (build_kamlahms)

  ⚠️ build_hmserp banate waqt REACT_APP_BRAND=hmserp ZAROOR set kijiye, warna hmserp.in par
     purana naam chala jaayega. API ka pata (REACT_APP_API_BASE) jaisa pehle tha waisa hi.
*/
export const BRAND = String(process.env.REACT_APP_BRAND || "").trim().toLowerCase();
export const IS_HMSERP = BRAND === "hmserp";
